import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form element js-animation form-additional" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "subtitle_a" }
const _hoisted_4 = { class: "subtitle_c" }
const _hoisted_5 = { class: "subtitle_b" }
const _hoisted_6 = { class: "subtitle_d" }

import { ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'AbstractSubmissionReceipt',
  props: {
  title: { type: String, default: 'termsAndConditions.reviewSubmission.title' },
  message: String,
  reason: String,
  header: String
},
  setup(__props, { expose: __expose }) {

const props = __props

const receiptNumber = ref('')

const updateReceipt = (newReceiptNumber: string) => {
  receiptNumber.value = newReceiptNumber
}

__expose({ updateReceipt })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(props.title)), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(props.header)), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("b", null, _toDisplayString(_ctx.$t(props.reason)), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("b", null, _toDisplayString(_ctx.$t('termsAndConditions.reviewSubmission.contact')), 1)
    ])
  ]))
}
}

})